import { Person, Restaurant } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { route } from '@/constants/routeName';

export default function ParentAppChrome() {
	const accountType = useSelector((state) => state.auth.accountType);
	if (accountType !== 'parent') return null;

	return (
		<header className='brand'>
			<div className='wordmark'>
				<Restaurant fontSize='small' aria-hidden='true' />
				<span>
					Jungle Toppings
					<small>Parent app</small>
				</span>
			</div>
			<Link to={`/${route.account}`} className='profile' aria-label='Family account'>
				<Person fontSize='small' />
			</Link>
		</header>
	);
}
